
import { createOrderViaEndpoint } from '@/lib/api/orderService';
import { Product } from '@/lib/supabase/products/types';
import { OrderFormData } from './types';
import { v4 as uuidv4 } from 'uuid';
import { pushToDataLayer, trackOrderCreation } from './trackingUtils';

export const submitOrder = async (
  product: Product,
  organizationId: string | null,
  shopId: string | undefined,
  formData: OrderFormData
) => {
  // Ensure we have a valid organization ID
  const effectiveOrgId = organizationId || product.organization_id;
  // Use the effective shop ID from the props or product
  const effectiveShopId = shopId || product.shop_id;
  
  if (!effectiveOrgId) {
    console.error("organizationId manquant:", effectiveOrgId);
    throw new Error("Données d'organisation manquantes");
  }
  
  if (!formData.customerName || !formData.customerPhone) {
    throw new Error("Veuillez remplir votre nom et numéro de téléphone");
  }
  
  // Generate a unique event_id for tracking
  const eventId = uuidv4();
  
  // Get or create external_id from localStorage
  let externalId = localStorage.getItem('tracking_external_id');
  if (!externalId) {
    externalId = `ext_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
    localStorage.setItem('tracking_external_id', externalId);
  }
  
  // Créer l'objet de commande avec toutes les données nécessaires
  const orderData = {
    organization_id: effectiveOrgId,
    shop_id: effectiveShopId || product.shop_id || null,
    customer: {
      name: formData.customerName,
      phone: formData.customerPhone,
      email: formData.customerEmail || "",
      address: formData.customerAddress || "",
      country: "Algeria",
      region: formData.customerRegion || "Alger",
      municipality: formData.customerMunicipality || "Alger"
    },
    external_id: `ORD-${Date.now()}`,
    items: [
      {
        product_id: product.id,
        product_name: product.name,
        price: product.price,
        quantity: formData.quantity,
        currency: product.currency || "DZD"
      }
    ],
    notes: formData.note || "",
    currency: product.currency || "DZD"
  };
  
  console.log("Envoi des données de commande:", orderData);
  
  // Send the order to the API
  const result = await createOrderViaEndpoint(orderData);
  
  // If order creation was successful, handle tracking
  if (result && typeof window !== 'undefined') {
    // Push to dataLayer
    pushToDataLayer(eventId, product, formData, result, effectiveOrgId, effectiveShopId);
    
    // Track the event server-side
    await trackOrderCreation({
      product,
      effectiveOrgId,
      effectiveShopId,
      eventId,
      externalId,
      formData,
      result
    });
  }
  
  return result;
};
